module.exports = __webpack_public_path__ + "static/IUEsergio-b0f339f3bb284eab6d58df5175bcc00c.jpg";